import { Action } from '@ngrx/store';
import { HttpError, UserCustomizationsModel } from '@rd/types';

export enum UserCustomizationsActionTypes {
  PUT_USER_CUSTOMIZATIONS = '[UserCustomizations] Put User Customizations',
  PUT_USER_CUSTOMIZATIONS_SUCCESS = '[UserCustomizations] Put User Customizations success',
  PUT_USER_CUSTOMIZATIONS_FAILED = '[UserCustomizations] Put User Customizations failed',
  GET_USER_CUSTOMIZATIONS = '[UserCustomizations] Get User Customizations',
  GET_USER_CUSTOMIZATIONS_SUCCESS = '[UserCustomizations] Get User Customizations success',
  GET_USER_CUSTOMIZATIONS_FAILED = '[UserCustomizations] Get User Customizations failed',
}

export class PutUserCustomizations implements Action {
  readonly type = UserCustomizationsActionTypes.PUT_USER_CUSTOMIZATIONS;

  constructor(public payload: UserCustomizationsModel) {}
}

export class PutUserCustomizationsSuccess implements Action {
  readonly type = UserCustomizationsActionTypes.PUT_USER_CUSTOMIZATIONS_SUCCESS;

  constructor() {}
}

export class PutUserCustomizationsFail implements Action {
  readonly type = UserCustomizationsActionTypes.PUT_USER_CUSTOMIZATIONS_FAILED;

  constructor(public payload: HttpError) {}
}

export class GetUserCustomizations implements Action {
  readonly type = UserCustomizationsActionTypes.GET_USER_CUSTOMIZATIONS;

  constructor() {}
}

export class GetUserCustomizationsSuccess implements Action {
  readonly type = UserCustomizationsActionTypes.GET_USER_CUSTOMIZATIONS_SUCCESS;

  constructor(public payload: UserCustomizationsModel) {}
}

export class GetUserCustomizationsFail implements Action {
  readonly type = UserCustomizationsActionTypes.GET_USER_CUSTOMIZATIONS_FAILED;

  constructor(public payload: HttpError) {}
}

export type UserCustomizationsActions =
  | PutUserCustomizations
  | PutUserCustomizationsSuccess
  | PutUserCustomizationsFail
  | GetUserCustomizations
  | GetUserCustomizationsSuccess
  | GetUserCustomizationsFail;
